import { styled, Stack } from "@mui/material";

export const ControlsContainer = styled(Stack)`
  padding: 0px 20px 20px 20px;
  row-gap: 24px;
`;

export const RedAsterisk = styled(`span`)`
  color: ${({ theme }) => theme.palette.error.main};
`;
